<template>
  <cf-validated-form
    name="chargeToRoom"
    :disabled="isProcessing"
    @valid-submit="submit"
  >
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Charge To Room
    </Teleport>

    <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
      <p class="cf-subtitle cf-subtitle--2">
        Please use the last name on the room reservation & your room number.
      </p>

      <cf-text-input
        v-model="roomLastName"
        type="text"
        label="Last Name"
        name="roomLastName"
        icon-class="fa-user-circle"
        :validations="{
          required: true
        }"
      />

      <cf-text-input
        v-model="roomNumber"
        type="text"
        label="Room Number"
        name="roomNumber"
        icon-class="fa-door-closed"
        :validations="{
          required: true
        }"
      />

      <cf-contact-information
        v-if="!hideContactInfo"
        v-model="contactInfo"
        :email-input-state="emailInputState"
        :phone-is-required="phoneIsRequired || session.smsReceiptOptIn"
      />

      <cf-sms-receipt-opt-in v-if="!hideSms" />

      <div
        v-if="showTotal"
        class="cf-flex cf-flex--column cf-flex--gap-10"
      >
        <h3 class="cf-title cf-title--3">
          Your Total
        </h3>

        <h3 class="cf-title cf-title--3">
          {{ $dollars(total) }}
        </h3>
      </div>

      <button
        :class="['cf-button cf-button--primary cf-button--lg', { 'cf-button--loading': isProcessing }]"
        type="submit"
      >
        {{ payCtaText }}
      </button>
    </div>
  </cf-validated-form>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfContactInformation from '@/view/components/globals/cf-contact-information/index.vue';
  import CfSmsReceiptOptIn from '@/view/components/globals/cf-sms-receipt-opt-in/index.vue';

  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export const validateEmailInputState = value => [
    'required',
    'optional',
    'hidden'
  ].includes(value);


  export default {
    name: 'CfChargeToRoom',

    components: {
      CfContactInformation,
      CfValidatedForm,
      CfSmsReceiptOptIn,
      CfTextInput
    },

    props: {
      emailInputState: {
        type: String,
        default: 'required',
        validator: validateEmailInputState
      },

      hideContactInfo: {
        type: Boolean,
        default: false
      },

      hideSms: {
        type: Boolean,
        default: false
      },

      payCtaText: {
        type: String,
        default: 'Pay'
      },

      phoneIsRequired: {
        type: Boolean,
        default: false
      },

      roomNumberAutofill: {
        type: String,
        default: null
      },

      showTotal: {
        type: Boolean,
        default: true
      },

      total: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        contactInfo: {},
        isProcessing: false,
        roomLastName: null,
        roomNumber: null
      };
    },

    computed: {
      ...mapGetters('giftCards', ['giftCards']),
      ...mapGetters('session', ['session'])
    },

    watch: {
      isProcessing: 'isProcessingChangeHandler'
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (this.roomNumberAutofill) {
          this.roomNumber = this.roomNumberAutofill;
        }
      },

      isProcessingChangeHandler(isProcessing) {
        if (isProcessing) {
          this.$lockModal('chargeToRoom');
        }

        else {
          this.$unlockModal('chargeToRoom');
        }
      },

      onCheckoutError() {
        this.isProcessing = false;

        this.$closeModal('chargeToRoom');
      },

      onCheckoutSuccess() {
        this.$closeModal('chargeToRoom');
      },

      submit() {
        this.isProcessing = true;

        this.$emit('checkout', {
          contactInfo: this.contactInfo,
          onCheckoutError: this.onCheckoutError,
          onCheckoutSuccess: this.onCheckoutSuccess,
          paymentMethod: {
            type: 'room-charge',
            roomLastName: this.roomLastName,
            roomNumber: this.roomNumber,
            giftCards: this.giftCards.appliedCards
          }
        });
      }
    }
  };
</script>
